import { useRouteError } from 'react-router-dom'
import { Flex, Text, Heading } from '@chakra-ui/react'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { SEO } from '../components/SEO'

export default function ErrorPage() {
  const error = useRouteError()
  console.error(error)

  return (
    <>
      <SEO title={t`Error | RushB.GG | Best CSGO Lootbox Platform`} />

      <Flex
        alignItems={'center'}
        justifyContent={'center'}
        w="100%"
        h="100vh"
        flexDir={'column'}
        gap={3}
      >
        <Heading as="h2">
          <Trans>Oops!</Trans>
        </Heading>
        <Text>
          <Trans>Sorry, an unexpected error has occurred.</Trans>
        </Text>
        {/* @ts-ignore */}
        <Text as={'i'}>{error.statusText || error.message}</Text>
      </Flex>
    </>
  )
}
